import React from "react";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";
import AdminTestDetails from "../../components/AdminTests/AdminTestDetails"


const AdminTestsDetails = () => {
  return (
    <div>
      <UserPage />      
      <AdminTestDetails />
      <Footer />
    </div>
  );
};

export default AdminTestsDetails;
